if ( module.hot ) {
    module.hot.accept();
}

window.gdw = {

    el:{
        // image captions
        imgs:$('#main img'),
        animateCounter:0,
        wW: $(window).width()
    },

    init:function(){
        this.bindUIEvents();
        this.changeNavBehavior();
        this.toggleLocationHours(1);
        this.calcMaxNavHeight(1);
        this.animateContactPod();
        this.evenFooterCols();
        this.initSlider();
        this.wrapYouTube();
        this.fixYouTubeEmbed();
        this.recordMakeAnAppt();
        $('[data-toggle="tooltip"]').tooltip();
        this.initAnimation();
        this.dropdownPosition();
        this.ieCheck();
    },

    bindUIEvents:function(){

        $('.gpw-banner-scroll-content').on('click', gdw.scrollToTarget);

        $('.expand-map').on('click', gdw.toggleMapPod);

        $('.show-contact-form').on('click', gdw.showContactForm);

        $('.location-radios .conradio').on('change', gdw.toggleLocationHours);

        $('#ie-warning #ie-dismiss').on('click', gdw.dismissIEWarning);

        // Change menu drop down behavior depending on document width
        $(window).on('resize', gdw.changeNavBehavior);

        // show mega menu details on menu item hover
        $('#navigation-snip').on('mouseenter', '.nav-link', function() {
            var targetID = $(this).data('id'),
                targetContent = $(".flyout-content").find("[data-id='" + targetID + "']");

            if ($(targetContent).is(':hidden')) {
                $('.mega-details').hide().css('position', 'absolute');
                targetContent.stop().fadeIn('fast').css('position', 'relative');
            }

        });

        $('#navigation-snip').on('mouseenter', '.nav > li a', function(event) {
            event.preventDefault();
            var firstNav = $(this).next('ul').find('a').eq(1),
                dropDown = $(this).next('ul');

            $(firstNav).trigger('mouseenter');
        });

       /*  $('.infusion-form').on('submit',function(event){
            gdw.recordContact;
        }); */

        /* Add theme styles to social icons on location pages */
        $('.social-location-links.social-links.white-social-icons a').addClass('theme-cta-bg');
        $('.social-location-links.social-links.white-social-icons a').hover(function() {
            $(this).removeClass('theme-cta-bg').addClass('theme-bg-dk');
        }, function() {
            $(this).removeClass('theme-bg-dk').addClass('theme-cta-bg');
        });

        /* This is to put the li in the mobile nav to the top to better view the dropdowns*/
        if ($(window).width() < 767) {
            /* set initial variable on load */
            var ddHeight = 0;

            /* function to see if any dropdown is open and get height */
            function findDDHeight() {
                $('#gpw-main-menu li.dropdown').each(function() {
                    if ($(this).hasClass('open')) {
                        ddHeight = $(this).find('ul.dropdown-menu').outerHeight();
                        return false;
                    } else {
                        ddHeight = 0
                    }
                });
            };

            /* make ul the offset parent */
            $('#gpw-main-menu ul.nav.navbar-nav').css('position', 'relative'); 
        
            /* do some calculations on where to scroll to on click */
            $('#gpw-main-menu li.dropdown').on('click', function() {
                if (!$(this).hasClass('open')) {
                    /* check for dropdown */
                    findDDHeight();
                    /* check for li position in #gpw-main-menu */
                    var liTopPos = $(this).position().top;
                    /* set the scroll top in relation to the dropdown menu */
                    var scrollTop = liTopPos - ddHeight;
                    /* make sure the scroll top is not negative, otherwise just use liTopPos */
                    if (scrollTop < 0) {
                        scrollTop = liTopPos;
                    }

                    $('#gpw-main-menu').animate({
                        scrollTop: scrollTop
                    }, 500);
                } 
            });
            
        }
        // Show dynamic mobile nav trigger for hamburger
        $('#ChangeToggle').click(function() {
            $('#navbar-hamburger').toggleClass('hidden');
            $('#navbar-close').toggleClass('hidden');
            $('.menu-hide').toggleClass('show-menu');
        });
    },

    /* Modified to also handle spear education videos */
    wrapYouTube:function(){
        var wrapiFrame = function() {
            if (!$(this).parent().hasClass('video-container')) {
                var w = $(this).prop('width');
                /* Check if width has % for a value */
                if (w.search("%") == "-1") {
                    var valType = "px";
                } else {
                    var valType = "";
                }
                var align = $(this).prop('align');
                var styles = "max-width:" + w + valType;

                return '<div class="auto-iframe-wrap" style="' + styles + '" ><div class="video-container"></div></div>';
            }
        };

        $('iframe[src*="youtube.com"]').wrap(wrapiFrame);
        $('iframe[src*="speareducation.com"]').wrap(wrapiFrame);
    },

    fixYouTubeEmbed:function() {
        $('iframe[src*="youtube.com"]').attr('src', function(i, e) {
            if (!e.match(/\?rel=0/)) {
            return e +'?rel=0'
            }
        });
    },

    toggleLocationHours:function(load){
        if ($('.location-radios .conradio:checked').length) {
            var target = "#" + $(this).data('targetdays');

            if (load) {
                target = "#" + $('.location-radios .conradio:checked').data('targetdays');
            }

            // hide all hours
            $('.location-days').hide();
            $(target).show();
        }
    },

    scrollToTarget:function(event){
        event.preventDefault();
        var target = $(this).data('target');
        $('html,body').animate({scrollTop:$(target).offset().top}, 800);
    },

    evenFooterCols:function(){ 
        $(document).ready(function() {
            var cols = $('.footer-col'),
                height = 0;

            $.each(cols, function(index, val) {
                height = ($(val).height() > height) ? $(val).height() : height;
            });

            $('.footer-col').css('min-height', height);
        });
    },

    calcMaxNavHeight:function(onload){
        if (gdw.el.wW === $(window).width()) { return; }

        var navParents = $('.navbar-header').parents(),
            isFixed = false;

            // Check if the nav is fixed (or any of the parent elements)
            $.each(navParents, function(index, val) {
                $(val).css('position') == 'fixed' ? isFixed = true: false;

                if (isFixed) {
                    return false;
                }
            });

            // We only need to calculate max nav height if the nav is fixed; Otherwise, users can scroll to the bottom of the nav.
            if (isFixed) {
                // iOS can fire the resize event on scroll so we need to check if the window has *actually* resized.
                if (gdw.el.wW !== $(window).width() || onload === 1) {
                    gdw.el.wW = $(window).width();
                    // Get the navbar offset from the top of the document.
                    // Get the navbar height.
                    // Add nabvar height and offset from the top of the document. The remainder is the space left over (in px) on the screen left for the drop down menu.
                    var navOffset = $(window).height() - ( $(".navbar-header").offset().top + $(".navbar-header").height() ) + "px";
                    
                    $(".navbar-collapse").css({ maxHeight: navOffset });
                    // This will trigger the dynmaic mobile nav menu height
                    $(".menu-hide").css({ maxHeight: navOffset });

                }

            // It's possible the user could change the orentation of their device. In that case, recursion.
            $(window).on('resize', function() {
                gdw.calcMaxNavHeight();
            });
        }
    },

    toggleMapPod:function(){
        var pod = $(this).parents('.podGmaps'),
            iframe = $(pod).find('iframe');

        if (pod.hasClass('short')) {
            $(pod).animate({height: '218px'}, 400);
            $(iframe).animate({height: '218px'}, 400);
            pod.removeClass('short');
            pod.find('i').removeClass('fa-expand');
            pod.find('i').addClass('fa-compress');
        } else {
            $(pod).animate({height: '90px'}, 400);
            $(iframe).animate({height: '90px'}, 400);
            pod.addClass('short');
            pod.find('i').removeClass('fa-compress');
            pod.find('i').addClass('fa-expand');
        }
    },

    animateContactPod:function(){
      // if there is actually a contact pod on the page
        if ($('.heightChecker').length) {
            var heightChecker = $('.heightChecker').offset().top,
                formOffset = $('.contact-pod').offset().top,
                secondInputOffset = $('#contactform > div').eq(2).offset().top,
                formShort = secondInputOffset - formOffset,
                formHeight = heightChecker - formOffset + 20;

            $('.contact-pod').css({'overflow':'hidden', 'height':formShort});

            $( '.contact-pod input' ).focus(function() {
                if ($(this).attr('type') !== 'submit' && !$('.contact-pod').hasClass('open')) {
                    $( '.contact-pod' ).animate({
                        height: formHeight
                    }, 500);
                    $('.contact-pod .pod-content').css('overflow', 'visible');
                    $('.contact-pod').addClass('open');
                }
            });

            $( '.minimize' ).click(function() {
                $('.contact-pod').removeClass('open');
                $( '.contact-pod' ).animate({
                    height: formShort
                }, 500);
            });
        }
    },

    changeNavBehavior:function(){
        var winWidth = $(window).width();
        if (winWidth > 767) {
            $('.navbar .dropdown > a').click(function(event) {
                // Only redirect if edit mode is not on and is not a touch device
                if ($(this).find('span.is-editable').length === 0) {
                    location.href = this.href;
                }
            });
        } else {
            $('.navbar .dropdown > a').off();
        }
    },

    recordCall:function(phoneNum){
        /* Send this Event to Google Analytics GDW Tracker*/
        if (typeof(ga) != "undefined") {
            ga('GDWTracker.send', 'event', 'Click to Call phone', 'Click/Touch', phoneNum.toString());
        }

        var currentAction = $('body').data('event');
        $.ajax({
            type: 'get',
            url: '/logging/recordCall/phoneNumber/' + phoneNum + '/currentAction/' + currentAction + '/currentURL/' + window.location.href,
            success: function(resp){},
            error: function(resp){}
        });
    },

    recordMakeAnAppt:function(){
        /* Send this Event to Google Analytics GDW Tracker*/
        if (typeof(ga) != "undefined") {
            var vendor = $('body').data('booking-vendor'),
                page = window.location.pathname;

            if (vendor === false) {
                vendor = "None";
            }

            function sendToGA() {
                var label = 'Online Booking - Site Setting: ' + vendor + ', Page: ' + page;
                ga('GDWTracker.send', 'event', 'Make an Appointment', 'Click/Touch', label);
            };

            /* Localmed is the only 3rd party booking provider with a visible tab a user can click, but it does not have the .gpw-booking class. This means the red tab will not record GA events.

            In order to do so, we add a click event for this tab. However, .gpw-booking also triggers a click event (in gpw-online-booking.js) for .localmed-tab. So we need to attach the GA event to the .localmed-tab instead of .gpw-booking when localmed is used to prevent double results being sent to GA. 

            -NM 3-11-2019 */
        
            if (vendor != "localMed") {
                $('.gpw-booking').on("click", sendToGA);
            } else {
                $('body').on("click", ".localmed-tab", sendToGA);
            }  
        }
    },

    /* recordContact:function(){
        currentEvent = $('body').data('event');
        $.ajax({
            type: 'get',
            url: '/contact/recordContact/currentEvent/' + currentEvent + '/currentURL/' + window.location.href,
            success: function(resp){},
            error: function(resp){}
        });
    },

    logOfferResponse:function(offerID,clicked,type){
        $.ajax({
            type: 'get',
            url: '/index.cfm?event=logOfferResponse&offerID=' + offerID + '&type=' + type + '&click=' + clicked,
            success: function(resp){},
            error: function(resp){}
        });
    },

    logOfferImpression:function(offerID){
        $.ajax({
            type: 'get',
            url: '/index.cfm?event=logOfferImpression&offerID=' + offerID ,
            success: function(resp){},
            error: function(resp){}
        });
    }, */

    initSlider:function(){
        $(document).ready(() => {
            var sliders = $('.init-slider');

            $.each(sliders, function(index, val) {
                var animation = ($(this).data('animation') === undefined) ? 'slide' : $(this).data('animation'),
                    pauseOnHover = ($(this).data('pause') === undefined) ? true : $(this).data('pause'),
                    controlNav = ($(this).data('control') === undefined) ? true : $(this).data('control'),
                    directionNav = ($(this).data('direction') === undefined) ? true : $(this).data('direction'),
                    slideshowSpeed = ($(this).data('speed') === undefined) ? 7000 : $(this).data('speed'),
                    touch = ($(this).data('touch') === undefined) ? true : $(this).data('touch'),
                    smoothHeight = ($(this).data('smooth-height') === undefined) ? false : $(this).data('smooth-height');

                $(val).flexslider({
                    animation: animation,
                    pauseOnHover: pauseOnHover,
                    controlNav: controlNav,
                    directionNav: directionNav,
                    slideshowSpeed: slideshowSpeed,
                    touch: touch,
                    smoothHeight: smoothHeight,
                    start: function(slider){
                        if (typeof ThemeControls !== 'undefined') {
                        ThemeControls.el.themerSlider = slider;
                        }
                    }
                });
            });
        });
    },

    initAnimation:function(){
        jQuery(document).ready(function() {
            // Global animations toggle (Appearance > Animations). When off, skip WOW
            // entirely so it never hides elements; the .animations-off CSS keeps any
            // hardcoded .wow content visible.
            if (document.body && jQuery(document.body).hasClass('animations-off')) {
                return;
            }
            var wow = new WOW({
                boxClass:     'wow',      // default
                animateClass: 'animated', // default
                offset:       0,          // default
                mobile:       false,       // default is true
                live:         true,        // default
            })
            wow.init();
        });
    },

    dropdownPosition: function() {
        var winWidth = $(window).width(),
            dropdownMenu = '.dropdown-menu';

        if (winWidth > 767) {
            $('li.dropdown').hover(function() {
                var $menu = $(this).find(dropdownMenu);

                // About/Services/Gallery always carry .dropdown, even with no submenu
                if (!$menu.length) {
                    return;
                }

                var ddMenuWidth = $menu.width(),
                    ddMenuLeft = $menu.offset().left,
                    winWidth = $(window).width();

                if (ddMenuWidth + ddMenuLeft > winWidth) {
                    $menu.addClass('pull-right');
                }
            }, function() {
                $(this).children(dropdownMenu).removeClass('pull-right');
            });
        }
    },

    makeStringURLFriendly: function(string) {
        /* First find all non alphanumeric characters and convert them to spaces, trim the whitespace on the edges */
        var string = string.replace(/[^a-zA-Z0-9_]/g, ' ').trim();
        /* Next, replace all whitespace gaps with a single - */
        string = string.replace(/\s+/g, '-');
        return string;
    },

    ieCheck: function() {
        var isIE = false;
        var ua = navigator.userAgent;

        // Check if IE: MSIE used to detect old IE and Trident used to newer IE
        if (ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1) {
            isIE = true;
        }

        //Check if the dismissed cookie exists
        if (document.cookie.indexOf("ieDismissed") > -1) {
            var dismissed = true;
        } else {
            var dismissed = false;
        }

        // If the warning module has not be dismissed, and the user is using IE
        if (!dismissed && isIE) {
            $('#ie-warning').show();
        }
    },

    dismissIEWarning: function() {
        // Set the cookie to check for later and hide the warning module
        document.cookie = "ieDismissed=true";      
        $('#ie-warning').hide();
    }

};

gdw.init();



// WEBPACK FOOTER //
// ./gpw-public.js